import { jsx as _jsx } from "react/jsx-runtime";
import { Button as MuiButton, CircularProgress } from '@mui/material';
export const ButtonLoading = props => (_jsx(CircularProgress, { style: { height: 28, width: 28 }, color: "inherit", ...props }));
export const Button = ({ loading, children, ...props }) => {
    return _jsx(MuiButton, { ...props, children: loading ? _jsx(ButtonLoading, {}) : children });
};
